import { InternalAuthProvider } from '@own-up/widgets-react/modules/auth/internal/hooks/internal-auth-provider';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { App } from './app';
import { ThemeProvider } from './components/theme-provider';
import { ToasterContainer } from './components/toaster';
import { store } from './redux';

render(
  <InternalAuthProvider apiBaseUrl={window.location.origin + '/api'}>
    <Provider store={store}>
      <ThemeProvider>
        <ToasterContainer />
        <Router>
          <Switch>
            <Route path="/:rateQuoteId?">
              <App />
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </Provider>
  </InternalAuthProvider>,
  document.getElementById('root')
);
